import { Box, TextField, Button, Divider } from '@mui/material'
import axios from 'axios'
import React, { useState } from 'react'
import { FaSave } from 'react-icons/fa'
import { IoIosSend } from 'react-icons/io'

function MessageForm(props) {
    const [fData, setFData] = useState({name:'',company:'',phone:'',email:'',address:'',description:''})
    const [loading, setLoading] = useState(false)
    const saveData = async()=>{
        props.fomrLoading(true)
        setLoading(true)
        if(fData.name ==='' || fData.phone ==='' || fData.email ==='' ){
            setLoading(false)
            props.fomrLoading(false)
            props.fomrStatus(0)
            alert('All fields are mandatory')
            return
        }
         await axios.get(`https://smartcardmarketingsystems.com/api/chatbot.php?name=${fData.name}&company=${fData.company}&phone=${fData.phone}&email=${fData.email}&address=${fData.address}&description=${fData.description}`);
        setLoading(false)
        props.fomrLoading(false)
        props.fomrStatus(1)
        setFData({name:'',company:'',phone:'',email:'',address:'',description:''})


    }
    return (
        <div>
            <h3 className='message-great'>
                Great! Thank you for expressing interest .
                To better assist you, please provide us with some essential information.
            </h3>
            <Divider />
            <form>
                <TextField size="small" label="Your Name" variant="outlined" sx={{ m: 1, width: '100%' }} 
                value={fData.name} onChange={(e)=>{setFData((prev)=>({...prev, name: e.target.value})) }} />

                <TextField size="small" label="Company Name" variant="outlined" sx={{ m: 1, width: '100%' }} 
                value={fData.company} onChange={(e)=>{setFData((prev)=>({...prev, company: e.target.value})) }} />

                <TextField size="small" label="Phone " variant="outlined" sx={{ m: 1, width: '100%' }} 
                value={fData.phone} onChange={(e)=>{setFData((prev)=>({...prev, phone: e.target.value})) }} />

                <TextField size="small" label="Email" variant="outlined" sx={{ m: 1, width: '100%' }} 
                value={fData.email} onChange={(e)=>{setFData((prev)=>({...prev, email: e.target.value})) }} />

                <TextField size="small" label="Address" variant="outlined" sx={{ m: 1, width: '100%' }} 
                value={fData.address} onChange={(e)=>{setFData((prev)=>({...prev, address: e.target.value})) }} />

                <TextField size="small" label="Description" variant="outlined" sx={{ m: 1, width: '100%' }} 
                value={fData.description} onChange={(e)=>{setFData((prev)=>({...prev, description: e.target.value})) }} />

                <Box className="text-center" sm={{ m: 1 }} >

                    <Button variant="contained" endIcon={<IoIosSend />}
                    onClick={saveData}
                    >
                        Send
                    </Button>
                </Box>
            </form>
        </div>
    )
}

export default MessageForm